import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Haley Halcyon
 * id F55F6161-5EE4-4168-881C-A50E671AC25F
 * name square-wave
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/square-wave.svg
 * tags
 * - Audio 
 */
export const SquareWaveIcon = createSvgIcon(<><path d="M2 2V12H4V4H11V22H22V12H20V20H13V2H2Z" /></>, 'SquareWaveIcon');
export default SquareWaveIcon